export default __webpack_public_path__ + "static/media/seat 2.d24bebcb.svg";